module.exports = "<p>\n  subpage-acondicionamiento-del-espacio works!\n</p>\n"